<template>
  <div>
    <!-- Desktop Dialog -->
    <div v-if="!$vuetify.breakpoint.mdAndDown">
      <v-dialog
        v-model="deactivateVisibility"
        width="450"
        transition="dialog-bottom-transition"
        role="dialog"
        aria-modal="true"
        :aria-label="$t('components.deactivatedNotification.title')"
      >
        <v-card>
          <v-card-text>
            <p class="sr-only">
              {{ $t("components.deactivatedNotification.title") }}
            </p>
            {{ $t("components.deactivatedNotification.info") }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              aria-label="Join Discord"
              color="primary"
              @click="toDiscord()"
            >
              {{ $t("components.deactivatedNotification.buttons.discord") }}
            </v-btn>
            <v-btn
              aria-label="Visit Facebook Page"
              color="primary"
              @click="toFbPage()"
            >
              {{ $t("components.deactivatedNotification.buttons.fbPage") }}
            </v-btn>
            <v-btn
              aria-label="Close Deactivation Notice"
              color="primary"
              class="accent--text"
              @click="deactivateVisibility = 0"
            >
              {{ $t("components.deactivatedNotification.buttons.close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!-- Mobile Banner -->
    <v-flex
      v-if="$vuetify.breakpoint.mdAndDown"
      xs12
      sm12
      md12
      lg12
    >
      <v-alert
        v-model="deactivateVisibility"
        dismissible
        type="info"
        class="mt-0 mb-0"
        role="alert"
        aria-live="polite"
      >
        {{ $t("components.deactivatedNotification.infoDialog") }}
        <span
          class="primary--text cursor-pointer"
          tabindex="0"
          role="link"
          aria-label="Join Discord"
          @click="toDiscord"
          @keypress.enter="toDiscord"
        >
          {{ $t("components.deactivatedNotification.buttons.discord") }}
        </span>
        {{ " " + $t("components.deactivatedNotification.or") + " " }}
        <span
          class="primary--text cursor-pointer"
          tabindex="0"
          role="link"
          aria-label="Visit Facebook Page"
          @click="toFbPage()"
          @keypress.enter="toFbPage()"
        >
          {{ $t("components.deactivatedNotification.buttons.fbPage") }}
        </span>
      </v-alert>
    </v-flex>
  </div>
</template>

<script>
import links from "@/constants/links.js";

export default {
    name: "DeactivatedNotification",
    data() {
        return {
            deactivateVisibility: 0
        }
    },
    watch: {
        deactivateVisibility() {
            if (this.$route.query.deactivated === "true") {
                // to main page
                this.$router.push({ query: {} });
            }
        }
    },
    beforeMount() {
        this.deactivateVisibility = this.$route.query.deactivated === "true";
    },
    methods: {
        toDiscord() {
            if (links && links.communities) {
                window.open(links.communities.discord);
            }
        },
        toFbPage() {
            if (links && links.communities) {
                window.open(links.communities.fbPage);
            }
        }
    }
};
</script>
